import ChevronRight from '@material-ui/icons/ChevronRight';
import { EditIcon } from 'assets/icons';
import { t } from 'i18next';
import { FC } from 'react';
import './styles.scss';

interface Props {
	userAvatar: string;
	playerName: string;
	description: string;
	onAvatarClick?: () => void;
	playerInitials: string;
	vipUserBackground: any;
	cyTestRef?: string;
	isRedirection?: boolean;
	redirectionUrl?: any;
	renderVipRankStars?: any;
	isVip?: boolean;
}

const AvatarCard: FC<Props> = ({
	userAvatar,
	playerName,
	description,
	onAvatarClick,
	playerInitials,
	vipUserBackground,
	cyTestRef,
	isRedirection,
	redirectionUrl,
	renderVipRankStars,
	isVip,
}) => {
	return (
		<div className="AvatarCard">
			<div className="AvatarCard__userInfo">
				<div className="AvatarCard__profile" onClick={onAvatarClick} data-cy={cyTestRef}>
					{userAvatar.length ? (
						<img src={userAvatar} alt="avatarImage" className="AvatarCard__avatar" />
					) : (
						<div className={`AvatarCard__initials ${vipUserBackground}`}>{playerInitials}</div>
					)}
					<EditIcon className="AvatarCard__editIcon" />
				</div>
				<span className="AvatarCard__info" onClick={redirectionUrl}>
					<p className="AvatarCard__playerName">
						{playerName} {isRedirection && <ChevronRight className="AvatarCard__icon" />}
					</p>
					<p className="AvatarCard__description">{description}</p>
				</span>
			</div>

			{isVip && (
				<div className="AvatarCard__vip" onClick={redirectionUrl}>
					<p className="AvatarCard__vipTitle">{t('vipRank')}</p>
					<span className="AvatarCard__vipStars">{renderVipRankStars}</span>
				</div>
			)}
		</div>
	);
};

export default AvatarCard;
